// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3XNko","label":"Radio_label__2yGJ1","checkMark":"Radio_checkMark__2OF82","disabled":"Radio_disabled__1KKq4"};